import { render, staticRenderFns } from "./badgeBronze.vue?vue&type=template&id=3b5cfdfa&"
import script from "./badgeBronze.vue?vue&type=script&lang=js&"
export * from "./badgeBronze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports